import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import { Validators } from '@angular/forms';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'

import { BaseRequestComponent }                from '../../baseclasses/BaseRequest.component';
import { BaseEntity }                from '../../baseclasses/BaseEntity';

//components
import {UserInfoComponent} from '../../components/ControlGroups/UserInfo.component';
import {CompletionDetailsComponent} from '../../components/ControlGroups/CompletionDetails.component';
import {GeneralDetailsComponent} from '../../components/ControlGroups/GeneralDetails.component';
import {ContactDetailsComponent} from '../../components/ControlGroups/ContactDetails.component';
import {CustomerRequirementsComponent} from '../../components/ControlGroups/CustomerRequirements.component';
import {CoolerDetailsComponent} from '../../components/ControlGroups/CoolerDetails.component';
import {FountainDetailsComponent} from '../../components/ControlGroups/FountainDetails.component';
import {VendorDetailsComponent} from '../../components/ControlGroups/VendorDetails.component';
import {AddressComponent} from '../../components/ControlGroups/Address.component';
import {NotesComponent} from '../../components/ControlGroups/Notes.component';
import {RequestHeaderComponent} from '../../components/Controls/RequestHeader.component';
import {ChangePhoneNumberDialogComponent} from '../../components/Employees/ChangePhoneNumberDialog.component';

//constants
import { Constants }         from '../../constants/Constants';

@Component({
  selector: 'my-equipment-install-request',
  templateUrl: './CreateEquipmentInstallRequest.component.html'
})
export class CreateEquipmentInstallRequestComponent extends BaseRequestComponent {

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;

    activityReasonFilter: filters.ActivityReasonFilter;
    

    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(GeneralDetailsComponent) generalDetailsComponent: GeneralDetailsComponent;
    @ViewChild(ContactDetailsComponent) contactDetailsComponent: ContactDetailsComponent;
    @ViewChild(CustomerRequirementsComponent) customerRequirementsComponent: CustomerRequirementsComponent;
    @ViewChild(CoolerDetailsComponent) coolerDetailsComponent: CoolerDetailsComponent;
    @ViewChild(FountainDetailsComponent) fountainDetailsComponent: FountainDetailsComponent;
    @ViewChild(VendorDetailsComponent) vendorDetailsComponent: VendorDetailsComponent;
    @ViewChild(AddressComponent) addressComponent: AddressComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;

    constructor() 
    { 
        super();
        this.activityReasonFilter = new filters.ActivityReasonFilter();
        this.activityReasonFilter.RequestTypeID = enums.RequestTypeEnum.EquipmentInstall;
    }

    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();

    }

    getRequestTypeID(){
        return enums.RequestTypeEnum.EquipmentInstall;
    }

    onSubmitClick(event: any){
        this.getRequest(true);
    }
    

    onSaveClick(event: any){
        
        this.requestToSave = {
            ID: this.requestID,
            RequestTypeID: enums.RequestTypeEnum.EquipmentInstall,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            GeneralInfo: this.generalDetailsComponent.generalInfo,
            ContactInfos: [this.contactDetailsComponent.contactInfo],
            CustomerRequirementInfo: this.customerRequirementsComponent.customerRequirementInfo,
            CoolerInfo: this.coolerDetailsComponent.coolerInfo,
            FountainInfo: this.fountainDetailsComponent.fountainInfo,
            VendorInfo: this.vendorDetailsComponent.vendorInfo,
            OtherInfo: this.notesComponent.otherInfo,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID, 
            SalesOfficeID: util.RequestUtil.GetSalesOfficeID(this.userInfoComponent, this.generalDetailsComponent),
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };
        
        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);

        this.requestToSave.CustomerRequirementInfo.CustomerAvailabilityStartString = this.customerRequirementsComponent.getStartTime();
        this.requestToSave.CustomerRequirementInfo.CustomerAvailabilityEndString = this.customerRequirementsComponent.getEndTime();

        if (this.userInfoComponent.request.PhoneNumber){
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }
        this.requestToSave.VendorLineItems = this.vendorDetailsComponent.vendorLineItemGrid.lineItems;
        this.requestToSave.FountainLineItems = this.fountainDetailsComponent.fountainLineItemGrid.lineItems;
        this.requestToSave.CoolerLineItems = this.coolerDetailsComponent.coolerLineItemGrid.lineItems;
        this.requestToSave.FountainInfo.Flavors = this.fountainDetailsComponent.getFlavors();

        
        this.requestToSave.RequestDays = util.RequestUtil.LoadRequestDays(this.requestToSave, this.customerRequirementsComponent.dayOfWeekMultiSelectComponent, enums.DayType.CustomerNotAvailable);
        this.requestToSave.RequestProductSizes = util.RequestUtil.LoadRequestProductSizes(this.requestToSave, this.coolerDetailsComponent.productSizeMultiSelectComponent);

        this.requestToSave.Addresses = [];
        if (util.AddressUtil.isAddressPopulated(this.addressComponent.address)){
            this.addressComponent.address.AddressTypeID = enums.AddressType.Equipment;
            this.requestToSave.Addresses.push(this.addressComponent.address);
        }

        this.requestToSave.RequestCustomers = util.RequestUtil.LoadRequestCustomersFromGrid(this.requestToSave, this.generalDetailsComponent.requestCustomerGridComponent, enums.RequestCustomerTypeEnum.AppliesTo);
        
        if (this.generalDetailsComponent.generalInfo.IncludeSurveyRequest)
        {
            this.requestToSave.RequestEquipmentClasses = util.RequestUtil.LoadRequestEquipmentClassesFromRequestInstalls(this.requestToSave);
        }
        this.requestToSave.VendorInfo.EquipmentLocations = this.vendorDetailsComponent.equipmentLocationsComponent.getEquipmentLocations();

        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);



    }
    onYes(event: ent.Response){
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any){
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any){
        //do nothing
    }

    onIncludeSurveyRequestChanged(checked: boolean){
        this.customerRequirementsComponent.showRequestedSurveyDate = checked;
        //this.customerRequirementsComponent.showEquipmentClass = checked;

        var crForm = this.customerRequirementsComponent.customerRequirementsForm;
        crForm.controls['requestedSurveyDate'].clearValidators();
        
        if (this.customerRequirementsComponent.showRequestedSurveyDate){
            crForm.controls['requestedSurveyDate'].setValidators(Validators.required);
        }
    }

    

    onCustomerTypeChanged(value: number){
        this.vendorDetailsComponent.setCustomerType(value);
    }


}